<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">系统管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">网站设置</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-list">
            <a-divider orientation="left">
            网站设置
            </a-divider>
            <a-form :label-col="{ span: 3 }" :wrapper-col="{ span: 6 }">
                <a-form-item label="网站名称">
                    <a-input v-model="detail.money1"/>
                </a-form-item>
                <a-form-item label="logo" class="site-logo">
                     <div class="clearfix">
                            <a-upload
                            action="/api/upload"
                            list-type="picture-card"
                            :file-list="fileList"
                            @preview="handlePreview"
                            @change="handleChange"
                            >
                                <div  v-if="fileList.length ==0">
                                    <a-icon type="plus" />
                                    <div class="ant-upload-text">
                                    Upload
                                    </div>
                                </div>
                            </a-upload>
                            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                                <img alt="example" style="width: 100%" :src="previewImage" />
                            </a-modal>
                        </div>
                        <div class="img-text">
                            <span>点击图片，可更换logo</span>
                            <span>支持JEPG、PNG格式</span>
                            <span>大小不超过5M(推荐尺寸：162*42)</span>
                        </div>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 6, offset: 3 }">
                    <a-button type="primary" @click="tocost">
                        确定
                    </a-button>
                </a-form-item>
            </a-form>
           
            
        </div>
    </div>
</template>

<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
    data(){
        return{
            detail:"",

            fileList: []
        }
    },
    mounted(){
        this.costdetail()
    },
    methods:{
        costdetail(){
            this.$axios.post('/api/kefu/setcustomercommissionpage',{

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.detail=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 佣金设置
        tocost(){
            this.$axios.post('/api/kefu/editsetcustomercommission',{
                money:this.detail.money,
                money1:this.detail.money1
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.costdetail()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/setsite.vue